 /* eslint-disable */

export default {
  calculateProgress: ({ commit, state, getters }, { field, value }) => {
    switch (field) {

    case 'name':
      if (value.length > 2 && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (value.length < 3 && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'email':
      const reg = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+[^<>()\.,;:\s@\"]{2,})$/

      if (value.match(reg) && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (!value.match(reg) && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'telephone':
      const telephoneReg = /\(\d{2,}\) \d{4,}\-\d{4}/
      if (value.match(telephoneReg) && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (!value.match(telephoneReg) && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'birthday':
      if (validateBirthdate(value) && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (!validateBirthdate(value) && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'ssn':
      if (validateCPF(value) && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (!validateCPF(value) && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'gender':
      if ((value == 0 || value == 1) && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'marital_status':
      if ((value != undefined || value != null) && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if ((value == undefined || value == null) && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'state':
      if ((value != undefined || value != null) && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

    if ((value == undefined || value == null) && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;
      
    case 'address_number':
      if (value.length !== 0 && !state.fields[field])
      incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (value.length == 0 && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'address_neighborhood':
      if (value.length > 0 && !state.fields[field])
      incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (value.length == 0 && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'city':
      if (value.length > 0 && !state.fields[field])
      incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (value.length == 0 && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'address':
      if (value.length > 0 && !state.fields[field])
      incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (value.length == 0 && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
      break;

    case 'experience':
      if (value.length > 0 && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (value.length <= 0 && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
        break;

    case 'formation':
      if (value.length > 0 && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (value.length <= 0 && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
        break;

    case 'language':
      if (value.length > 0 && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (value.length <= 0 && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
        break;

    case 'skill':
      if (value.length > 0 && !state.fields[field])
        incrementProgress({ commit, field, progress: getters.progressByFiels })

      if (value.length <= 0 && state.fields[field])
        decrementProgress({ commit, field, progress: getters.progressByFiels })
        break;

      
      default:
        break;
    }
    
  },

  calculateBasicProgress: async ({ dispatch }, payload) => new Promise((resolve) => {
    const { basic } = payload['data'].data
    Object.keys(basic).map(async field => await dispatch('calculateProgress', { field, value: basic[field] }))
    resolve(payload)
  }),

  calculateAddressProgress: async ({ dispatch }, payload) => new Promise((resolve) => {
    const { address } = payload['data'].data
    Object.keys(address).map(async field => await dispatch('calculateProgress', { field, value: address[field] }))
    resolve(payload)
  }),

  calculateAddressProgress: async ({ dispatch }, payload) => new Promise(resolve => {
      const { address } = payload['data'].data
      Object.keys(address).map( async field => await dispatch('calculateProgress', { field, value: address[field] }))
      resolve(payload)
    }),
   
  calculateExperienceProgress: async ({ dispatch }, payload) => new Promise(resolve => {
      const { experiences } = payload['data'].data
      dispatch('calculateProgress', { field: 'experience', value: experiences })
      resolve(payload)
    }),

  calculateFormationProgress: async ({ dispatch }, payload) => new Promise(resolve => {
    const { formations } = payload['data'].data
    dispatch('calculateProgress', { field: 'formation', value: formations })
    resolve(payload)
    }),

  calculateLanguageProgress: async ({ dispatch }, payload) => new Promise(resolve => {
    const { languages } = payload['data'].data
    dispatch('calculateProgress', { field: 'language', value: languages })
    resolve(payload)
    }),

  calculateSkillProgress: async ({ dispatch }, payload) => new Promise(resolve => {
    const { skills } = payload['data'].data
    dispatch('calculateProgress', { field: 'skill', value: skills })
    resolve(payload)
    }),
}

const incrementProgress = ({ commit, field, progress }) => {
  commit('FILLED_MODULE_FIELD', { field })
  commit('INCREMENT_CURRENT_PROGRESS', { progress })
}

const decrementProgress = ({ commit, field, progress }) => {
  commit('NOT_FILLED_MODULE_FIELD', { field })
  commit('DECREMENT_CURRENT_PROGRESS', { progress })
}

const validateCPF = value => {

  const cpfReg = /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/
  if (!value.match(cpfReg)) return false

  const replaced = value.replace(/\./g, '').replace(/\-/g, '')

  let sum = 0
  let rest = 0

  for (let i=1; i<=9; i++) sum += parseInt(replaced.substring(i-1, i)) * (11 - i)
  rest = (sum * 10) % 11

  if ((rest == 10) || (rest == 11)) rest = 0
  if (rest != parseInt(replaced.substring(9,10))) return false

  sum = 0

  for (let i=1; i <=10; i++) sum += parseInt(replaced.substring(i-1, i)) * (12 - i)
  rest = (sum * 10) % 11

  if ((rest == 10) || (rest == 11)) rest = 0
  if (rest != parseInt(replaced.substring(10,11))) return false

  return true
}

const validateBirthdate = value => {

  const splitDate = value.split('/')

  const dayReg = /(0[1-9]|[12]\d|3[01])/
  const monthReg = /0[1-9]|1[0-2]/
  const yearReg = /(?:(?:19|20)[0-9]{2})/

  return splitDate[0].match(dayReg) && splitDate[1].match(monthReg) &&  splitDate[2].match(yearReg)
}